export const iconFontAwesomeSecurityHandsBound = (
	<i className="fa-solid fa-hands-bound"></i>
);
